import { WebshopOrderEndpoint as WebshopOrderEndpointInterface } from '@apiClient/interfaces/endpoints/WebshopOrder.endpoint';
import ApiResponseDto from '@apiClient/interfaces/response/ApiResponse.dto';
import { KyInstance } from "ky/distribution/types/ky";
import { KyResponse } from 'ky';
import CheckoutDto from '@/projectRoot/api-client/interfaces/models/webshop/checkout/Checkout.dto';
import OrderDto from '@/projectRoot/api-client/interfaces/models/webshop/order/Order.dto';
import OrderSearchRequestDto from '@/projectRoot/api-client/interfaces/request/webshop/OrderSearchRequest.dto';
import { buildSearchParams } from '@/projectRoot/src/utils/handlers/urlHandler';

export class WebshopOrderEndpoint implements WebshopOrderEndpointInterface {

    private _httpClient: KyInstance;
    private cache: RequestCache;

    public constructor(client: KyInstance, cache: RequestCache = "force-cache") {
        this._httpClient = client;
        this.cache = cache;
    }

    get httpClient(): KyInstance {
        if (!this._httpClient) {
            throw new Error('Ky http client is not initialized');
        }
        return this._httpClient;
    }

    set httpClient(kyInstance: KyInstance) {
        this._httpClient = kyInstance;
    }

    /**
     * /api/webshop/order/{id}
     */
    async single(id: string): Promise<ApiResponseDto<OrderDto, undefined>> {
        return this._httpClient
            .get(`webshop/order/${id}`, { cache: this.cache })
            .then(async (kyResponse: KyResponse) => {
                if (kyResponse.status < 200 || kyResponse.status > 299) {
                    throw new Error(kyResponse.statusText)
                }
                const response: ApiResponseDto<OrderDto, undefined> = await kyResponse.json();
                return response;
            });
    }

    /**
     * /api/webshop/order/search
     */
    async search(): Promise<ApiResponseDto<OrderDto[], undefined>> {
        return this._httpClient
            .get(`webshop/order`, { cache: this.cache})
            .then(async (kyResponse: KyResponse) => {
                if (kyResponse.status < 200 || kyResponse.status > 299) {
                    throw new Error(kyResponse.statusText)
                }
                const response: ApiResponseDto<OrderDto[], undefined> = await kyResponse.json();
                return response;
            });
    }
}

export default WebshopOrderEndpoint;